module.exports = __webpack_public_path__ + "static/media/add-circle.f8f1813f.svg";